import { EquipmentCalculatorSectionKey } from "../../calculationTypes";
import type { Section } from "../types";
import { ScenarioDetailSectionKey } from "../types";

export const buildOperatingParametersSideCalculatorSection = (): Section => ({
  id: EquipmentCalculatorSectionKey.OPERATING_PARAMETERS,
  hash: ScenarioDetailSectionKey.OPERATING_PARAMETERS,
  label: "Operating Parameters",
  routeName: "SizingParameters",
  aggregateDisplays: []
});

export const buildWellCompletionSideCalculatorSection = (): Section => ({
  id: EquipmentCalculatorSectionKey.WELL_COMPLETION,
  hash: ScenarioDetailSectionKey.WELL_COMPLETION,
  label: "Well Completion",
  routeName: "WellInfo",
  aggregateDisplays: []
});
